import React from 'react';
import Icon from './Icon';

function MasterCard({ title, description, count, icon, color = 'purple', onClick }) {
  return (
    <button className={`master-category-card ${color}`} onClick={onClick}>
      <span className="master-category-icon">{icon}</span>
      <span className="master-category-copy">
        <strong>{title}</strong>
        <small>{description}</small>
        <em>{count} {count === 1 ? 'entry' : 'entries'}</em>
      </span>
      <span className="master-category-arrow"><Icon name="arrowRight" /></span>
    </button>
  );
}

export default MasterCard;
